
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kiosks/[cName]/product/[productId]",
      function () {
        return require("private-next-pages/kiosks/[cName]/product/[productId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kiosks/[cName]/product/[productId]"])
      });
    }
  